import React, { useEffect, useState, useCallback } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Input,
  Label,
  Row,
} from "reactstrap";
import { Modal, Table, notification } from "antd";
import moment from "moment";
import { Link, useSearchParams } from "react-router-dom";
import AddApplicant from "components/Applicant/AddApplicant";
import {
  CallFindAllUsersByParams,
  CallUpdateStatus,
  CallCreateAdmin,
} from "services/apiAction";

const VendorListing = () => {
  const [api, contextHolder] = notification.useNotification();
  const [loading, setLoading] = useState(false);
  const [schoolData, setSchoolData] = useState([]);
  const [modal, setModal] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [totalCounts, setTotalCounts] = useState(0);
  const [schoolCounts, setSchoolCounts] = useState(0);
  const [studentCounts, setStudentCounts] = useState(0);

  const [searchParams, setSearchParams] = useSearchParams();

  const defaultPage = 1;
  const defaultLimit = 20;
  const defaultSearch = "";
  const defaultRole = "vendor";

  const pageNo = parseInt(searchParams.get("page") || defaultPage);
  const limit = parseInt(searchParams.get("limit") || defaultLimit);
  const searchTerm = searchParams.get("search") || defaultSearch;
  const role = searchParams.get("role") || defaultRole;

  const [search, setSearch] = useState(searchTerm);
  const [data, setData] = useState([]);

  const fetchVendorData = async (page = pageNo, limitVal = limit, searchVal = search) => {
    try {
      setLoading(true);

      const query = `page=${page}&limit=${limitVal}&role=${role}${
        searchVal ? `&searchPara=${searchVal}` : ""
      }`;

      const res = await CallFindAllUsersByParams(query);
      if (res?.data?.message === "Success") {
        setData(
          res.data.admin.map((item, index) => ({ ...item, key: index }))
        );
        setTotalCounts(res?.data?.totalCount || 0);
        setSchoolCounts(res?.data?.schoolCount || 0);
        setStudentCounts(res?.data?.studentCount || 0);
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchSchoolData = async () => {
    try {
      setLoading(true);

      const res = await CallFindAllUsersByParams("role=school");
      if (res?.data?.message === "Success") {
        setSchoolData(
          res.data.admin.map((item) => ({
            value: item?._id,
            label: `${item.firstName} ${item.lastName}`,
          }))
        );
      }
    } finally {
      setLoading(false);
    }
  };

useEffect(() => {
    fetchSchoolData();
  }, []);

  useEffect(() => {
    fetchVendorData(pageNo, limit, searchTerm);
  }, [pageNo, limit, searchTerm]);

  useEffect(() => {
    const delay = setTimeout(() => {
      setSearchParams({
        page: pageNo.toString(),
        limit: limit.toString(),
        search,
        role,
      });
      fetchVendorData(pageNo, limit, search);
    }, 500);

    return () => clearTimeout(delay);
  }, [search]);

const handleEdit = async (id, status, name) => {
    try {
      const formData = new FormData();
      formData.append(name === "status" ? "status" : "isChecked", !status);

      const res = await CallUpdateStatus(id, formData);

      if (res?.data?.message === "Success") {
        api.success({ message: "Updated Successfully", duration: 2 });
        fetchVendorData(pageNo, limit, search);
      }
    } catch (error) {
      console.error(error);
    }
  };

const handlePageChange = useCallback(
    (page, pageSize) => {
      setSearchParams({
        page: page.toString(),
        limit: pageSize.toString(),
        search,
        role,
      });
    },
    [search, role]
  );

const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    password: "",
    schoolsAdminId: [],
    role: "vendor",
  });

  const createVendor = async (e) => {
    e.preventDefault();
    try {
      setIsSubmit(true);

      const res = await CallCreateAdmin(JSON.stringify(userData));

      if (res?.data?.message === "Success") {
        api.success({ message: "Vendor Created", duration: 2 });
        setModal(false);
        fetchVendorData();
      }
    } finally {
      setIsSubmit(false);
    }
  };

  const columns = [
    {
      title: "Sr No.",
      render: (id, data, idx) => idx + 1 + limit * (pageNo - 1),
    },
    {
      title: "Name",
      render: (id, item) => `${item.firstName} ${item.lastName}`,
    },
    { title: "Mobile", dataIndex: "mobile" },
    { title: "Email", dataIndex: "email" },
    {
      title: "Created Date",
      dataIndex: "created_at",
      render: (date) => moment(date).format("ll"),
    },
    {
      title: "Status",
      render: (id, item) => (
        <Label className="custom-toggle custom-toggle-warning">
          <Input
            type="checkbox"
            defaultChecked={item?.status}
            onClick={() => handleEdit(item._id, item.status, "status")}
          />
          <span className="custom-toggle-slider rounded-circle" />
        </Label>
      ),
    },
    {
      title: "Checked",
      render: (id, item) => (
        <Label className="custom-toggle custom-toggle-warning">
          <Input
            type="checkbox"
            defaultChecked={item?.isChecked}
            onClick={() => handleEdit(item._id, item.isChecked, "checked")}
          />
          <span className="custom-toggle-slider rounded-circle" />
        </Label>
      ),
    },
    {
      title: "Action",
      render: (id, item) => (
        <Button
          tag={Link}
          to={`/admin/vendor/school-listing/${item._id}`}
          size="sm"
          color="white"
        >
          <i className="fas fa-eye text-primary" />
        </Button>
      ),
    },
  ];

  return (
    <Container className="my-5" fluid>
      {contextHolder}

      <Row>
        <div className="col">
          <Card className="shadow">

            <CardHeader className="border-0 pb-0 d-flex justify-content-between flex-wrap">
              <div className="d-flex align-items-center">
              <h3 className="mb-0 mr-3">Vendor List</h3>
              <Card className="p-1 mb-0" style={{ backgroundColor: "#f7fafc" }}>
                <span className="mr-3 font-weight-bold">
                  Total Vendors:
                  <Button color="primary" size="sm" className="ml-3 mr--3">
                    {totalCounts}
                  </Button>
                </span>
              </Card>
              <Card className="p-1 mb-0 ml-3" style={{ backgroundColor: "#f7fafc" }}>
                <span className="mr-3 font-weight-bold">
                  Total Schools:
                  <Button color="primary" size="sm" className="ml-3 mr--3">
                    {schoolCounts}
                  </Button>
                </span>
              </Card>
              <Card className="p-1 mb-0 ml-3" style={{ backgroundColor: "#f7fafc" }}>
                <span className="mr-3 font-weight-bold">
                  Total Students:
                  <Button color="primary" size="sm" className="ml-3 mr--3">
                    {studentCounts}
                  </Button>
                </span>
              </Card>
              </div>
              <div className="d-flex align-items-center mt-2 mt-md-0">

                <Button
                  className="p-2 mr-3"
                  color="primary"
                  size="sm"
                  onClick={() => setModal(true)}
                >
                  Add_Vendor
                </Button>

                <Input
                  placeholder="Search"
                  className="rounded-pill"
                  value={search}
                  type="search"
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </CardHeader>

            <CardBody>
              <div className="table-responsive">
                <Table
                  dataSource={data}
                  columns={columns}
                  loading={loading}
                  pagination={{
                    current: pageNo,
                    pageSize: limit,
                    total: totalCounts,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    onChange: handlePageChange,
                  }}
                  scroll={{ x: "max-content" }}
                />
              </div>
            </CardBody>
          </Card>
        </div>
      </Row>

      <Modal
        title="Add Vendor"
        open={modal}
        onCancel={() => setModal(false)}
        footer={null}
      >
        <AddApplicant
          role="vendor"
          handleChange={(e) =>
            setUserData({ ...userData, [e.target.name]: e.target.value })
          }
          assignedSchool={setUserData}
          userData={userData}
          createAdmin={createVendor}
          loading={isSubmit}
          options={schoolData}
        />
      </Modal>
    </Container>
  );
};

export default VendorListing;